export default {"src":"/_next/static/media/successCircleDarkGrey.8d21b2c7.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};